<div class="pl-3 d-flex align-items-center" *ngIf="showBackBtn">
  <button
    type="button"
    class="btn p-0 mr-2 text-gray"
    aria-label="Back button"
    (click)="onBack && onBack()"
  >
    <i class="fas fa-arrow-left"></i>
  </button>
  <span class="mr-3 clickable text-gray" (click)="onBack && onBack()">{{
    'News' | translate
  }}</span>
</div>

<div class="news-details">
  <ng-container *ngIf="canViewDetails">
    <div class="d-flex align-items-center justify-content-between mb-3 mt-3">
      <div *ngIf="currentOrg" class="d-flex align-items-center mb-3">
        <button
          class="filter__btn mr-2 filter__btn--active flex-shrink-0"
          id="filterCollapse"
        >
          <app-internal-icon
            [hasFilter]="false"
            [height]="20"
            [iconType]="IconType.PNG"
            [name]="InternalIcon.InnovationSpace"
          ></app-internal-icon>
        </button>
        <span class="flex-shrink-0" translate>UI.News.ThisPostBelongsTo</span>

        <span class="font-weight-bold text-truncate">
          &nbsp;{{ currentOrg?.name || 'All Innovation Spaces' | translate }}
        </span>
      </div>
    </div>

    <div
      class="d-flex flex-column flex-md-row gap-8 justify-content-between mb-3 mt-3"
    >
      <div class="d-flex news-details__header gap-8">
        <div
          class="sender-profile d-flex justify-content-center details__header__info"
          *ngIf="senderProfileImg"
        >
          <div class="rounded-circle">
            <a
              class="d-inline-block jip-upper-first-letter font-weight-bold"
              [href]="peopleURL + '/' + senderId"
            >
              <img
                alt="profile image"
                [src]="senderProfileImg"
                appDefaultAvatar
                appDynamicImgUrl
              />
            </a>
          </div>
          <span
            class="underline justify-content-center d-inline-block align-content-center jip-upper-first-letter font-weight-bold ml-2"
          >
            {{ senderName }}
          </span>
        </div>
        <div class="d-flex align-items-center news-details__header__info">
          <span class="divider d-flex hidden-xs">|</span>

          <ng-container *ngIf="showDate">
            <span class="d-inline-block text-medium-gray">
              {{ dateTime }}
            </span>
          </ng-container>
        </div>

        <div class="d-flex align-items-center details__header__info">
          <span class="divider d-flex align-items-center hidden-xs">|</span>

          <app-internal-icon
            [hasFilter]="false"
            [height]="20"
            [iconType]="IconType.SVG"
            [name]="InternalIcon.CopyLink"
          ></app-internal-icon>

          <span
            class="ml-1 text-medium-gray clickable"
            [ngbTooltip]="
              copied
                ? ('UI.Common.Copied' | translate)
                : ('UI.Common.Copy' | translate)
            "
            (click)="copyPostLink && copyPostLink()"
          >
            {{
              copied
                ? ('UI.Common.Copied' | translate)
                : ('UI.Common.Copy' | translate)
            }}
          </span>
        </div>
      </div>

      <div
        class="text-right news-details__category d-flex align-items-center"
        *ngIf="categoryName"
      >
        <span class="font-weight-bold" translate>UI.Categories.Category</span>:
        <span
          class="text-medium-gray ml-1 text-truncate"
          [ngbTooltip]="categoryName"
          >{{ categoryName }}</span
        >
      </div>
    </div>

    <div class="news-details__content">
      <div *ngIf="rawHtml" class="news-details__content">
        <span [innerHTML]="rawHtml"></span>
        <hr class="d-inline-block" />
      </div>

      <div
        class="text-medium-gray"
        *ngIf="streams && streamNames && !(isLoadingStreamOptions$ | async)"
      >
        <span class="flex-shrink-0 font-weight-bold" translate
          >UI.PublishingStreams.Label</span
        >:
        <span class="stream-items">{{ streamNames }}</span>
      </div>
    </div>
  </ng-container>
</div>
